import { Token, WETH } from '@pancakeswap/sdk'
import {
  GRX_CHAIN_ID,
  ROBINHOOD_MAINNET_CHAIN_ID,
  ROBINHOOD_TESTNET_CHAIN_ID,
} from './chains'

export const WRAPPED_NATIVE = {
  [GRX_CHAIN_ID]: new Token(
    GRX_CHAIN_ID,
    '0x45C7287F897B3A79Cd3f6e4F14B4CE568f023bD5',
    18,
    'WGRX',
    'Wrapped GRX',
  ),

  [ROBINHOOD_TESTNET_CHAIN_ID]: new Token(
    ROBINHOOD_TESTNET_CHAIN_ID,
    '0x458a1AC838d22a4A236Df64B2fb1F1Af5b473Ced',
    18,
    'WETH',
    'Wrapped Ether',
  ),

  [ROBINHOOD_MAINNET_CHAIN_ID]: new Token(
    ROBINHOOD_MAINNET_CHAIN_ID,
    '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73',
    18,
    'WETH',
    'Wrapped Ether',
  ),
} as const

// Pancake SDK internally reads WETH[chainId] while constructing routes.
// Register the wrapped-native tokens for the custom Robinhood chains.
;(WETH as any)[ROBINHOOD_TESTNET_CHAIN_ID] =
  WRAPPED_NATIVE[ROBINHOOD_TESTNET_CHAIN_ID]

;(WETH as any)[ROBINHOOD_MAINNET_CHAIN_ID] =
  WRAPPED_NATIVE[ROBINHOOD_MAINNET_CHAIN_ID]

export const getWrappedNative = (
  chainId?: number,
): Token | undefined =>
  chainId
    ? WRAPPED_NATIVE[chainId as keyof typeof WRAPPED_NATIVE]
    : undefined
